module.exports = __webpack_public_path__ + "static/media/7.7.2bc02e2d.png";